<template>
  <div>
    <v-card>
      <v-card-title>Presupuesto de Ventas</v-card-title>
      <v-card-text>
        <div>
          <v-row >
            <v-col class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mx-2"
                    color="blue darken-1"
                    dark
                    right
                    fab
                    small
                    @click="dialog = true"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <i class="material-icons">add</i>
                  </v-btn>
                </template>
                <span>Agregar Presupuesto</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mx-2"
                    color="green darken-1"
                    dark
                    right
                    fab
                    small
                    @click="upload = !upload"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <i class="material-icons">upload</i>
                  </v-btn>
                </template>
                <span>Cargar Presupuestos</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
    <div class="card">
      <div class="card-header card-header-primary card-header-icon">
        <div class="card-icon" style="background: #1565C0 !important;">
          <i class="material-icons">list</i>
        </div>
        <h4 class="card-title">
          <div class="row">
            <div class="col-md-6">
              Listado de Presupuestos
            </div>
            <div class="col-md-6">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Escriba Para buscar Presupuesto"
                single-line
                hide-details
              ></v-text-field>
            </div>
          </div>
        </h4>
      </div>
      <div class="card-body">
        <div class="toolbar">
          <!--        Here you can write extra buttons/actions for the toolbar              -->
        </div>
        <div class="material-datatables">
          <v-data-table 
            :headers="presupuestosListHeaders"
            :items="presupuestosListBody"
            class="elevation-1 mx-0"
            label="Escriba Para buscar Presupuesto" 
            no-data-text="Listado de Presupuestos"
            fixed-header
            :search="search"
            :header-props="{ sortIcon: 'arrow_upward' }"
            :footer-props="{
              showFirstLastPage: true,
              firstIcon: 'first_page',
              lastIcon: 'last_page',
              prevIcon: 'navigate_befores',
              nextIcon: 'navigate_next'
              //'items-per-page-options':[5,10,20],
            }"
          >
            <template v-slot:item.month="{ item }">
              <span>{{ months[item.month - 1].nombre }}</span>
            </template>
            <template v-slot:[`item.actions`]="{item}">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-icon
                    medium
                    class="mr-2"
                    style="cursor:pointer;color:orange;"
                    @click="editPresupuesto(item, false)"
                    v-on="on"
                  >
                    edit
                  </v-icon>
                </template>
                <span>Editar presupuesto</span>
              </v-tooltip>
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-icon
                    medium
                    @click="deletePresupuesto(item)"
                    v-on="on"
                    style="cursor:pointer;color:red;"
                  >
                  delete
                  </v-icon>
                </template>
                <span>Eliminar presupuesto</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </div>
    </div>
    <!-- Modal Nuevo Presupuesto -->
    <v-dialog
      v-model="dialog"
      width="800px"
      @click:outside = "closeModal"
    >
      <v-card>
        <v-card-title class="blue darken-1">{{ title }}</v-card-title>
        <v-card-text>
          <v-row class="mx-2">
            <v-col
              class="align-center justify-space-between"
              cols="4"
            >
              <v-select 
                prepend-icon="mdi-factory"
                v-model="presupuesto.year"
                :items="years"
                item-text="nombre"
                item-value="id"
                label="Año"
                color="blue darken-3"
              >
              </v-select>
            </v-col>
            <v-col cols="4">
              <v-select 
                prepend-icon="mdi-factory"
                v-model="presupuesto.month"
                :items="months"
                item-text="nombre"
                item-value="id"
                label="Mes"
                color="blue darken-3"
                @change="setInicioTermino"
              >
              </v-select>
            </v-col>
            <v-col cols="4">
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="inicio_formated"
                  label="Fecha de Inicio"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
                </template>
                <v-date-picker
                  v-model = "presupuesto.inicio"
                  @input = "menu1 = false"
                  locale = "es-cl"
                  prev-icon="chevron_left"
                  next-icon="chevron_right"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="termino_formated"
                    label="Fecha de Termino"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model = "presupuesto.fin"
                  @input = "menu2 = false"
                  locale = "es-cl"
                  prev-icon="chevron_left"
                  next-icon="chevron_right"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="closeModal"
          >Cerrar</v-btn>
          <v-btn
            color="primary"
            @click="savePresupuesto"
          >Grabar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / Modal -->

    <!-- Modal upload -->
    <v-dialog
      v-model="upload"
      width="600px"
    >
      <v-card>
        <v-card-title class="green darken-1">
          Subir listado de presupuestos desde excel
        </v-card-title>
        <v-card-text>
          <v-row class="mx-2">
            <v-file-input v-model="file" accept=".xls, .xlsx" label="Archivo Excel"></v-file-input>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="upload = false"
          >Cancelar</v-btn>
          <v-btn
            color="primary"
            @click="uploadPresupuesto"
          >Subir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / Modal -->

    <v-snackbar
      v-model="snackbar"
      :timeout="5000"
      :color="color"
    >
      {{ validation_message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    data: () => ({
      title: 'Nueva Presupuesto',
      color: 'green',
      snackbar: false,
      errors: [],
      validation_message: '',
      success: null,
      search: null,
      menu1: null,
      menu2: null,
      dialog: false,
      presupuestoIndex: -1,
      years: [],
      months: [],
      upload: false,
      file: null,
      presupuesto: {
        id: 0,
        year: 0,
        month: 0,
        inicio: null,
        fin: null
      },
      presupuestosListHeaders: [
        {
          text: 'Cliente',
          align: 'left',
          sortable: true,
          value: 'empresa.razon_social',
          class: "blue-grey darken-4 white-text"
        },
        {
          text: 'Año',
          align: 'center',
          sortable: true,
          value: 'year',
          class: "blue-grey darken-4 white-text"
        },
        {
          text: 'Mes',
          align: 'center',
          sortable: true,
          value: 'month',
          class: "blue-grey darken-4 white-text"
        },
        {
          text: 'Biomasa',
          align: 'center',
          sortable: true,
          value: 'biomasa',
          class: "blue-grey darken-4 white-text"
        },
        {
          text: 'Ventas',
          align: 'center',
          sortable: true,
          value: 'ventas',
          class: "blue-grey darken-4 white-text"
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          class: "blue-grey darken-4 white-text"
        },
      ],
      presupuestosListBody: [],
      botones:[
        {boton:'crear', tooltip:'Nueva Presupuesto'},
        //{boton:'cargar',tooltip:'Carga Masiva'},
        //{boton:'eliminar',tooltip:'Borrar Todo'}
      ]
    }),
    mounted() {
        this.loadPresupuestos();
        this.presupuesto.year = this.moment().format('YYYY');
        this.years.push({id: parseInt(this.presupuesto.year) - 1, nombre: parseInt(this.presupuesto.year) - 1});
        this.years.push({id: this.presupuesto.year, nombre: this.presupuesto.year});
        this.years.push({id: parseInt(this.presupuesto.year) + 1, nombre: parseInt(this.presupuesto.year) + 1});
        this.months = [
          {id: 1, nombre: 'Enero'},
          {id: 2, nombre: 'Febrero'},
          {id: 3, nombre: 'Marzo'},
          {id: 4, nombre: 'Abril'},
          {id: 5, nombre: 'Mayo'},
          {id: 6, nombre: 'Junio'},
          {id: 7, nombre: 'Julio'},
          {id: 8, nombre: 'Agosto'},
          {id: 9, nombre: 'Septiembre'},
          {id: 10, nombre: 'Octubre'},
          {id: 11, nombre: 'Noviembre'},
          {id: 12, nombre: 'Diciembre'},
        ];
        this.presupuesto.month = this.moment().clone().format('M');
        this.presupuesto.inicio  = this.moment().clone().startOf('month').format('YYYY-MM-DD');
        this.presupuesto.fin = this.moment().clone().endOf('month').format('YYYY-MM-DD');
    },
    methods:{
      setInicioTermino(){
        let ym = `${this.presupuesto.year}-${this.presupuesto.month}-01`;
        this.presupuesto.inicio  = this.moment(ym).clone().startOf('month').format('YYYY-MM-DD');
        this.presupuesto.fin = this.moment(ym).clone().endOf('month').format('YYYY-MM-DD');
      },
      async loadPresupuestos(){
        this.mostrarLoading('Cargando listado de presupuestos...')
        let url = `${this.base_url}presupuesto_ventas`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.presupuestosListBody = response.data;
            this.ocultarLoading()
        }).catch((error)=>{
            console.log(error);
            this.ocultarLoading()
        });
      },
      async savePresupuesto(){
        // validation
        this.errors = [];
        if(!this.presupuesto.year){
          this.errors.push("Debe indicar año");
        }
        if(!this.presupuesto.month){
          this.errors.push("Debe indicar mes");
        }
        if(!this.presupuesto.inicio){
          this.errors.push("Debe indicar fecha de inicio");
        }
        if(!this.presupuesto.fin){
          this.errors.push("Debe indicar fecha de termino");
        }
        if(this.errors.length > 0){
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
          return;
        }
        let url = `${this.base_url}presupuesto_ventas`;
        let presupuestoData = {
          'year': this.presupuesto.year,
          'month': this.presupuesto.month,
          'inicio': this.presupuesto.inicio,
          'fin': this.presupuesto.fin,
        };
        if(this.presupuesto.id > 0){
          url = url + "/" + this.presupuesto.id;
          await this.axios.put(url, presupuestoData, this.headers).then((response)=>{
            console.log(response);
            this.loadPresupuestos();
            this.showSnackBar(false);
          }).catch((error)=>{
            this.validation_message = error;
            this.showSnackBar(true);
          });
        }else{
          await this.axios.post(url, presupuestoData, this.headers).then((response)=>{
            console.log(response);
            this.loadPresupuestos();
            this.showSnackBar(false);
          }).catch((error)=>{
            this.errors = error.response.data;
            this.validation_message = this.errors.join();
            this.showSnackBar(true);
          });
        }
        this.cleanForm();
      },
      editPresupuesto(item) {
        this.presupuestoIndex = this.presupuestosListBody.indexOf(item);
        this.presupuesto = Object.assign({}, item);
        this.dialog = true;
        this.title = "Editar Presupuesto";
      },
      async deletePresupuesto(item) {
        this.$confirm('Desea borrar este presupuesto?').then(res => {
          if(res){
            let url = `${this.base_url}presupuesto_ventas/${item.id}`;
            this.axios.delete(url, this.headers).then((response)=>{
              console.log(response);
              this.loadPresupuestos();
              this.showSnackBar(false);
            }).catch((error)=>{
              this.validation_message = error;
              this.showSnackBar(true);
            });
          }
        });
      },
      showSnackBar(error){
        if(error){
          this.color = 'red';
        }else{
          this.color = 'green';
          this.validation_message = "Ejecutado exitosamente!";
        }
        this.snackbar = true;
      },
      closeModal(){
        this.cleanForm();
        this.dialog = false;
        this.error = null;
        this.title = "Nuevo Presupuesto";
      },
      cleanForm(){
        this.presupuesto = {
          id: 0,
          nombre: '',
        };
        this.dialog = false;
      },
      formatDate(date) {
        if (!date) return '';
        const [year, month, day] = date.split('-');
        return `${day}-${month}-${year}`;
      },
      formatISO(date) {
        if (!date) return '';
        const [day, month, year] = date.split('-');
        return `${year}-${month}-${day}`;
      },
      async uploadPresupuesto(){
        this.headers.headers['Content-Type'] = "multipart/form-data";
        let url = `${this.base_url}uploads/presupuesto_ventas`;
        let formData = new FormData();
        formData.append("excel", this.file);
        let response = null; 
        try{
          response = await this.axios.post(url, formData, this.headers);
          this.file = null;
          this.upload = false;
          this.loadPresupuestos();
          this.showSnackBar(false);
        }catch(error){
          response = error.response;
          let msg = response.data.data;
          this.validation_message = response.status + ': ' + response.data.message + '. '+ msg;
          this.showSnackBar(true);
        }
      },
      ...mapMutations(['actualizarBaseUrl', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['loading', 'base_url', 'headers']),
      inicio_formated () {
        return this.formatDate(this.presupuesto.inicio)
      },
      termino_formated () {
        return this.formatDate(this.presupuesto.fin)
      },
    },
    components:{
      
    }
  }
</script>